import React, { useState } from "react";
import officeService from "../office/officeService";
import TooltipInput from "../../NewUPT/ToolTip/TooltipInput";
import TooltipTextArea from "../../NewUPT/ToolTip/TooltipTextArea";
import "../registration/ptRegDesign.css"; // Make sure this includes .form-wrapper styling

const officeServiceInstance = new officeService();

const RegisterOffice = () => {
  const [form, setForm] = useState({
    officeName: "",
    address: "",
    description: "",
    phoneNumber: "",
    email: "",
    officeKey: "",
    officeImage: "",
  });

  const handleChange = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const officeData = {
      officeName: form.officeName.trim(),
      address: form.address.trim(),
      description: form.description.trim(),
      phoneNumber: form.phoneNumber.trim(),
      email: form.email.trim(),
      officeKey: "",      // assigned later
      officeImage: "",    // assigned later
    };

    try {
      const response = await officeServiceInstance.addOffice(officeData);
      alert("Office Registration Successful: " + JSON.stringify(response));
    } catch (error) {
      alert("Registration Failed: " + error.message);
    }
  };

  return (
    <div className="form-wrapper">
      <form id="officeRegistrationForm" onSubmit={handleSubmit}>
        <TooltipInput
          label="Office Name"
          type="text"
          id="officeName"
          placeholder="Enter Office Name"
          tooltip="The name of the office."
          value={form.officeName}
          onChange={(v) => handleChange("officeName", v)}
           required
        />
        <TooltipInput
          label="Address"
          type="text"
          id="address"
          placeholder="Enter Address"
          tooltip="The full address of the office."
          value={form.address}
          onChange={(v) => handleChange("address", v)}
        />
        <TooltipTextArea
          label="Description"
          id="description"
          placeholder="Enter Description"
          tooltip="A brief description of the office."
          value={form.description}
          onChange={(v) => handleChange("description", v)}
        />
        <TooltipInput
          label="Phone Number"
          type="text"
          id="phoneNumber"
          placeholder="Enter Phone Number"
          tooltip="The office's contact number."
          value={form.phoneNumber}
          onChange={(v) => handleChange("phoneNumber", v)}
        />
        <TooltipInput
          label="Email"
          type="email"
          id="email"
          placeholder="Enter Email"
          tooltip="The office's email address."
          value={form.email}
          onChange={(v) => handleChange("email", v)}
        />

        {/* Hidden fields just in case needed later */}
        <input type="hidden" id="officeKey" value={form.officeKey} />
        <input type="hidden" id="officeImage" value={form.officeImage} />

        <button type="submit">Register Office</button>
      </form>
    </div>
  );
};

export default RegisterOffice;
